import { ytFetch } from "@/services";
import MOCK_LOWCODE from "./mock/lowcode";
import { type TPageType } from "@/types/types";

interface IRelatedPageInfo {
  datasetId: number;
  pageInfo: {
    id: number;
    type: TPageType;
  }[];
}

interface IPageInfo {
  appCode: string;
  pageId: number;
  code: string;
  // detailCode?: string;
  relatedPageInfoList?: IRelatedPageInfo[];
  nodePermitList?: {
    resourceCode: string;
    allowedActions: ("access" | "0")[];
  }[];
}

/**
 * 异步请求低码页面信息
 * @param id: 页面id
 * @returns
 */
export const getLowcodePageInfo = async (id: string | number) => {
  if (!id) return;
  return ytFetch.get<IPageInfo>("api/page/detail", { pageId: id });
};

/**
 * 异步获取 json schema
 * @param id: 页面id
 * @returns
 */
export const getSchema = async (id: string) => {
  if (!id) return;
  let schema;
  try {
    const pageInfo = await getLowcodePageInfo(id);
    schema = pageInfo.code;
  } catch {
    // TODO: 请求失败时, 暂时用mock数据替代
    schema = MOCK_LOWCODE.schema;
  }
  return schema;
};
